new Plyr('#product-details-video', {
    controls: [
        "progress",
        "play"
    ],
    disableContextMenu: false,
    loop: {
        active: true
    },
    hideControls: false,
    fullscreen: {
        enabled: false
    },
    tooltips: {
        controls: false,
        seek: false
    }
});